import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90f3aeb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Home ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" JSON-string ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" JSON-url ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "nav__link",
      "data-test": "route-home"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: "/stringpaste",
      class: "nav__link",
      "data-test": "route-stringpaste"
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: "/linkpaste",
      class: "nav__link",
      "data-test": "route-linkpaste"
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    })
  ]))
}